import { parseDecimalInput } from '../../shared/numeric/localeNumeric';
import type { CorrectStockCostForm, InventoryFlowResult } from './inventoryOperations.types';

export function parseCorrectStockCostForm(
  ctx: { canEdit: boolean; canViewValuation?: boolean },
  form: CorrectStockCostForm
): InventoryFlowResult<{ productId: string; avgCost: number }> {
  if (!ctx.canEdit) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'info',
        title: 'Solo lectura',
        message: 'No tenés permiso para corregir el costo.',
      },
    };
  }
  if (!ctx.canViewValuation) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'info',
        title: 'Solo lectura',
        message: 'No tenés permiso para corregir el costo.',
      },
    };
  }
  if (!form.stockRow) {
    return { kind: 'blocked', notice: { tone: 'error', title: 'Error', message: 'Elegí un producto.' } };
  }
  const avgCost = parseDecimalInput(String(form.costInput), { min: 0 });
  // Costo 0 pisa la valuación del producto a $0 — no es un camino válido acá.
  if (avgCost === null || avgCost <= 0) {
    return {
      kind: 'blocked',
      notice: {
        tone: 'error',
        title: 'Costo inválido',
        message: 'Ingresá el precio al que lo comprás, mayor a cero (ej. 120 o 120,50).',
      },
    };
  }
  return {
    kind: 'done',
    refresh: { stocks: true, branchActivity: true, dashboard: true },
    data: { productId: form.stockRow.productId, avgCost },
  };
}
